'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _popOver = require('../pop-over');

var _popOver2 = _interopRequireDefault(_popOver);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _getPopOverPosition = require('../internal/get-pop-over-position');

var _getPopOverPosition2 = _interopRequireDefault(_getPopOverPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = 'IconMenu';

var propTypes = {
  /** Icon to toggle the menu with */
  icon: _propTypes2.default.node.isRequired,
  /** Content of the IconMenu (MenuItems) */
  children: _propTypes2.default.node.isRequired,
  /** Secondary set of MenuItems */
  secondaryMenuItems: _propTypes2.default.node,
  /** Text to divide the menu items */
  dividerText: _propTypes2.default.node,
  /** Optional header text */
  header: _propTypes2.default.node,
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the content container */
  contentStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when the IconMenu closes
   *
   * function(event: object) => void
   */
  onMenuClose: _propTypes2.default.func,
  /** Override the styles of the divider element */
  dividerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when the IconMenu's header is clicked
   *
   * function(event: object) => void
   */
  onHeaderClick: _propTypes2.default.func,
  /** Override the styles of the Button component */
  buttonStyle: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

var defaultProps = {
  header: null,
  style: {},
  headerStyle: {},
  contentStyle: {},
  dividerStyle: {},
  secondaryMenuItems: null,
  dividerText: null,
  onMenuClose: _noop2.default,
  onHeaderClick: _noop2.default,
  buttonStyle: {}
};

/** Open a menu from an Icon, give options related to the icon */

var IconMenu = function (_Component) {
  _inherits(IconMenu, _Component);

  function IconMenu() {
    _classCallCheck(this, IconMenu);

    var _this = _possibleConstructorReturn(this, (IconMenu.__proto__ || Object.getPrototypeOf(IconMenu)).call(this));

    _this.handleClickOutside = function (event) {
      return _this.closeMenu(event);
    };

    _this.handleKeyUp = function (event) {
      if (event.which === 27) {
        _this.closeMenu();
      }
    };

    _this.state = {
      open: false,
      positioned: false
    };

    _this.openMenu = _this.openMenu.bind(_this);
    _this.closeMenu = _this.closeMenu.bind(_this);
    _this.positionPopOver = _this.positionPopOver.bind(_this);
    _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
    return _this;
  }

  _createClass(IconMenu, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _state = this.state,
          open = _state.open,
          positioned = _state.positioned;


      if (open && !positioned) {
        this.positionPopOver();
      }
    }
  }, {
    key: 'positionPopOver',
    value: function positionPopOver() {
      var button = this.button.getBoundingClientRect();
      var popOver = this.popOver.getBoundingClientRect();

      this.setState({
        positioned: true,
        position: (0, _getPopOverPosition2.default)(button, popOver)
      });
    }
  }, {
    key: 'openMenu',
    value: function openMenu() {
      this.setState({
        open: true
      });
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu(event) {
      var onMenuClose = this.props.onMenuClose;
      var open = this.state.open;


      if (!open) {
        return false;
      }

      this.setState({
        open: false,
        positioned: false
      });

      return onMenuClose(event);
    }
  }, {
    key: 'applyCloseMenuToChildren',
    value: function applyCloseMenuToChildren(children) {
      var _this2 = this;

      return _react2.default.Children.map(children, function (child) {
        return _react2.default.cloneElement(child, { closeMenu: _this2.closeMenu });
      });
    }
  }, {
    key: 'handleHeaderClick',
    value: function handleHeaderClick(event) {
      var onHeaderClick = this.props.onHeaderClick;


      onHeaderClick(event);
      this.closeMenu(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          secondaryMenuItems = _props.secondaryMenuItems,
          header = _props.header,
          icon = _props.icon,
          headerStyle = _props.headerStyle,
          style = _props.style,
          contentStyle = _props.contentStyle,
          dividerText = _props.dividerText,
          onMenuClose = _props.onMenuClose,
          eventTypes = _props.eventTypes,
          outsideClickIgnoreClass = _props.outsideClickIgnoreClass,
          preventDefault = _props.preventDefault,
          stopPropagation = _props.stopPropagation,
          disableOnClickOutside = _props.disableOnClickOutside,
          enableOnClickOutside = _props.enableOnClickOutside,
          dividerStyle = _props.dividerStyle,
          onHeaderClick = _props.onHeaderClick,
          buttonStyle = _props.buttonStyle,
          custom = _objectWithoutProperties(_props, ['children', 'secondaryMenuItems', 'header', 'icon', 'headerStyle', 'style', 'contentStyle', 'dividerText', 'onMenuClose', 'eventTypes', 'outsideClickIgnoreClass', 'preventDefault', 'stopPropagation', 'disableOnClickOutside', 'enableOnClickOutside', 'dividerStyle', 'onHeaderClick', 'buttonStyle']);

      var _state2 = this.state,
          open = _state2.open,
          position = _state2.position;


      var menuItemsWithProps = this.applyCloseMenuToChildren(children);
      var secondaryMenuItemsWithProps = null;

      if (secondaryMenuItems) {
        secondaryMenuItemsWithProps = this.applyCloseMenuToChildren(secondaryMenuItems);
      }

      return _react2.default.createElement(
        'div',
        _extends({ style: _getStyles2.default.root(style) }, custom),
        open ? _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onResize: this.closeMenu,
          onKeyUp: this.handleKeyUp
        }) : null,
        _react2.default.createElement(
          'div',
          { ref: function ref(button) {
              _this3.button = button;
            } },
          _react2.default.createElement(
            _button2.default,
            {
              style: buttonStyle,
              iconButton: true,
              onClick: !open ? this.openMenu : this.closeMenu
            },
            icon
          )
        ),
        _react2.default.createElement(
          _popOver2.default,
          {
            style: contentStyle,
            header: header,
            headerStyle: headerStyle,
            open: open,
            popOverRef: function popOverRef(popOver) {
              _this3.popOver = popOver;
            },
            position: position,
            secondaryMenuItems: secondaryMenuItemsWithProps,
            dividerText: dividerText,
            dividerStyle: dividerStyle,
            onHeaderClick: this.handleHeaderClick
          },
          menuItemsWithProps
        )
      );
    }
  }]);

  return IconMenu;
}(_react.Component);

IconMenu.displayName = displayName;
IconMenu.propTypes = propTypes;
IconMenu.defaultProps = defaultProps;

exports.default = IconMenu;
module.exports = exports.default;